import { chartTableFlatTransformer } from '@/utils/reports/chartTableFlatTransformer';

// Calculate NPS: ((Promoters - Detractors) / Total Responses) × 100
const calculateNPS = (promoters = 0, passives = 0, detractors = 0) => {
  const totalResponses = promoters + passives + detractors;
  if (totalResponses === 0) return 0;
  return Math.round(((promoters - detractors) / totalResponses) * 100);
};

const tableWithTotal = (data) => {
  // Calculate totals for candidate NPS
  const candidate_promoters_total = data?.reduce(
    (acc, curr) => acc + (curr?.candidate_promoters || 0),
    0
  );
  const candidate_passives_total = data?.reduce(
    (acc, curr) => acc + (curr?.candidate_passives || 0),
    0
  );
  const candidate_detractors_total = data?.reduce(
    (acc, curr) => acc + (curr?.candidate_detractors || 0),
    0
  );
  const candidate_nps_total = calculateNPS(
    candidate_promoters_total,
    candidate_passives_total,
    candidate_detractors_total
  );

  // Calculate totals for hm (hiring manager) NPS
  const hm_promoters_total = data?.reduce(
    (acc, curr) => acc + (curr?.hm_promoters || 0),
    0
  );
  const hm_passives_total = data?.reduce(
    (acc, curr) => acc + (curr?.hm_passives || 0),
    0
  );
  const hm_detractors_total = data?.reduce(
    (acc, curr) => acc + (curr?.hm_detractors || 0),
    0
  );
  const hm_nps_total = calculateNPS(
    hm_promoters_total,
    hm_passives_total,
    hm_detractors_total
  );

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      // Calculate NPS for this row
      const candidate_nps = calculateNPS(
        datum?.candidate_promoters,
        datum?.candidate_passives,
        datum?.candidate_detractors
      );
      const hm_nps = calculateNPS(
        datum?.hm_promoters,
        datum?.hm_passives,
        datum?.hm_detractors
      );

      return {
        ...datum,

        // Add calculated NPS values for this row
        candidate_nps,
        hm_nps,

        // Add NPS totals
        candidate_nps_total,
        hm_nps_total,

        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

export const surveyTableTransformer = ({ response, args }) => {
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {}; // Lookup mappings for data transformation

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};

  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1Key: group_by_1?.id || group_by_1,
    g2Key: group_by_2?.id || group_by_2,
  });

  const tableData = tableWithTotal(transformedData);

  return tableData;
};
